import { createContext, useContext, useEffect, useRef, useState } from "react";
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { checkSession } from '../../api/login/UserLogin';
import { getMemberDetails, getSwagItems } from '../../api/member/MemberDashboardAPI';
import ErrorPage from "../ErrorPage";
import UnauthorizedPage from "../UnauthorizedPage";
import Page from "../../components/Page";



const MemberContext = createContext();

export const MemberProvider = ({ children }) => {

    const [member, setMember] = useState(null);
    const [memberIsActive, setMemberIsActive] = useState(false);
    const [activeSemesters, setActiveSemesters] = useState(0);
    const [activeMemberRules, setActiveMemberRules] = useState([]);
    const [swagItems, setSwagItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [apiSuccess, setApiSuccess] = useState(true);
    const [roles, setRoles] = useState([]);

    const navigate = useNavigate();
    const location = useLocation();

    const intervalId = useRef(null);

    useEffect(() => {( async () => {
        setLoading(true); // Start loading
        const allRoles = await checkSession(location.pathname, navigate);
        setRoles(allRoles);
        console.log(allRoles);
        intervalId.current = setInterval(() => {
            checkSession(location.pathname, navigate);
        }, 15 * 60 * 1000); // every 15 min, check session

        // Cleanup interval on unmount
        return () => clearInterval(intervalId.current);
    })();
    }, []);


    useEffect(() => {
        (async () => {
            try {
                const swagData = await getSwagItems();
                const memberInfo = await getMemberDetails();

                setMember(memberInfo);
                setActiveMemberRules(memberInfo.membershipDetails.rules);
                setMemberIsActive(memberInfo.status === "Active");
                setActiveSemesters(memberInfo.activeMemberSemestersCount >= memberInfo.manualSemesterCount ? memberInfo.activeMemberSemestersCount : memberInfo.manualSemesterCount);
                setSwagItems(swagData);
            } catch (error) {
                setApiSuccess(false);
                console.error("Error fetching member data:", error);
            } finally {
                setLoading(false); // Stop loading once data is fetched
            }
        })();

    }, []);

    const correctRolesForPage = ["MEMBER"].some(r => roles.includes(r));

    if (loading) {
        return (
            <Page>
                <div>
                    Loading....
                </div>
            </Page>
            
        );
    }

    if (!correctRolesForPage && !loading) {
        return (
            <UnauthorizedPage />
        )
    }

    return (
        <MemberContext.Provider value={{ roles, member, setMember, activeSemesters, memberIsActive, activeMemberRules, swagItems, loading, apiSuccess}}>
            { children }
        </MemberContext.Provider>

    );
};

export const MemberLayout = () => {
    return (
        <MemberProvider>
            <Outlet />
        </MemberProvider>
    );
};

export const useMember = () => useContext(MemberContext);